import { z } from 'zod';

// 1. Zodiac Sign Schema
export const ZodiacSignSchema = z.object({
    sign: z.string(),
    number: z.number().min(0).max(12), // Allow 0 for unknown
    age: z.number().optional().nullable()
});

// 2. Gematria Schema
export const GematriaSchema = z.object({
    sign: z.string(),
    number: z.number().min(0).max(12), // Allow 0
    gematria: z.number()
});

// 3. Profile Schema
const ProfileSchema = z.object({
    profileNumber: z.number(),
    profileSign: z.string(),
    zodiacPosition: z.number().min(0).max(12) // Allow 0
});

// 4. Tur Schema
export const TurSchema = z.object({
    value: z.enum(['א', 'ב', 'ג', 'ד', 'ה', 'ו', '-']),
    label: z.string()
});

// 5. Numerology Schema
export const NumerologySchema = z.object({
    dayNumber: z.number().min(0).max(9), // Allow 0
    monthNumber: z.number().min(0).max(9),
    yearNumber: z.number().min(0).max(9),
    totalNumber: z.number().min(0).max(9),
    totalFromAllDigits: z.number(),
    firstNumber: z.number(),
    familyNumber: z.number(),
    totalNameNumber: z.number(),
    eheviNumber: z.number(),
    itzurimNumber: z.number(),
    eheviInnerSumFirst: z.number(),
    eheviInnerSumFamily: z.number(),
    itzurimInnerSumFirst: z.number(),
    itzurimInnerSumFamily: z.number(),
    fullInnerSum: z.number(),
    eheviInnerSum: z.number(),
    itzurimInnerSum: z.number(),
    full2InnerSum: z.number(),
    hamashaOuterSum: z.number(),
    hamashaInnerSum: z.number()
});

// 6. Esoteric Completeness Flags Schema
export const EsotericCompletenessFlagsSchema = z.object({
    canCalculateHouses: z.boolean(),
    isMoonVolatile: z.boolean(),
    hasAstrology: z.boolean(),
    hasNumerology: z.boolean(),
    hasShabtai: z.boolean(),
    missingFields: z.array(z.string())
});

// 7. Full Calculation Result
export const CalculationResultSchema = z.object({
    innerSign: ZodiacSignSchema,
    surroundingSign: GematriaSchema,
    profile: ProfileSchema,
    numerology: NumerologySchema,
    tur: TurSchema,
    completenessFlags: EsotericCompletenessFlagsSchema.optional()
});


// 7. Input Schema (for Excel/Form)
const hebrewOnly = (val: string | null | undefined) => !val || !/[a-zA-Z]/.test(val);
const HEBREW_ONLY_MSG = "אנא השתמש באותיות בעברית בלבד (ללא אנגלית)";

export const CalculationInputSchema = z.object({
    firstName: z.string()
        .min(1, "שם פרטי הוא שדה חובה")
        .refine(hebrewOnly, HEBREW_ONLY_MSG),
    familyName: z.string()
        .refine(hebrewOnly, HEBREW_ONLY_MSG),
    motherName: z.string()
        .optional()
        .nullable()
        .refine(hebrewOnly, HEBREW_ONLY_MSG),
    birthDate: z.union([
        z.string().regex(/^\d{2}\/\d{2}\/\d{4}$/, "יש להזין תאריך בפורמט DD/MM/YYYY"),
        z.literal('')
    ]),
    birthTime: z.string().regex(/^\d{2}:\d{2}$/, "יש להזין זמן בפורמט HH:MM").optional().nullable(),
    cityName: z.string().max(200).optional().nullable(),
    lat: z.number().optional().nullable(),
    lng: z.number().optional().nullable(),
    timezone: z.string().optional().nullable()
});
